"use client";

import { useState } from "react";
import {
  Dialog,
  DialogPortal,
  DialogBackdrop,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
  DialogClose,
  Button,
} from "@/ui";
import { AITextField } from "@components/shared/form/ai";
import { createRecruitingPrompt } from "@/lib/agent/utils/candidateToPrompt";
import FormSection from "./parts/FormSection";
import FormFieldTitle from "./parts/FormFieldTitle";

export default function EditSummary({ onClose, open, candidate, onUpdate }) {
  const [summary, setSummary] = useState({
    highlights: candidate?.highlights || "",
    summary: candidate?.summary || "",
    introduction: candidate?.introduction || "",
  });

  const handleFieldChange = (field) => (value) => {
    setSummary((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onUpdate({ ...candidate, ...summary });
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogPortal>
        <DialogBackdrop />
        <DialogContent size="lg">
          <DialogHeader>
            <DialogTitle>Edit summary</DialogTitle>
            <DialogClose />
          </DialogHeader>
          <DialogBody>
            <FormSection>
              <FormFieldTitle>Highlights:</FormFieldTitle>
              <AITextField
                value={summary.highlights}
                onChange={handleFieldChange("highlights")}
                placeholder="Enter key highlights for this candidate..."
                prompt={createRecruitingPrompt(candidate, "highlights")}
                variant="input"
                fullWidth
              />
            </FormSection>
            <FormSection>
              <FormFieldTitle>Short introduction:</FormFieldTitle>
              <AITextField
                value={summary.summary}
                onChange={handleFieldChange("summary")}
                placeholder="Write a short introduction for this candidate..."
                prompt={createRecruitingPrompt(candidate, "summary")}
                variant="textarea"
                minRows={3}
                maxRows={6}
                fullWidth
              />
            </FormSection>
            <FormSection>
              <FormFieldTitle>Long introduction:</FormFieldTitle>
              <AITextField
                value={summary.introduction}
                onChange={handleFieldChange("introduction")}
                placeholder="Write a detailed introduction for this candidate..."
                prompt={createRecruitingPrompt(candidate, "introduction")}
                variant="textarea"
                minRows={5}
                maxRows={10}
                fullWidth
              />
            </FormSection>
          </DialogBody>
          <DialogFooter>
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={handleSubmit}>Save changes</Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
